import React from 'react';

const BrandLogosSection = () => {
  // 35 real brand logos (more will be added later)
  const logos = [
    { id: 1, name: 'Brand 1', url: '/brands/brand-1.png' },
    { id: 2, name: 'Brand 2', url: '/brands/brand-2.png' },
    { id: 3, name: 'Brand 3', url: '/brands/brand-3.png' },
    { id: 4, name: 'Brand 4', url: '/brands/brand-4.png' },
    { id: 5, name: 'Brand 5', url: '/brands/brand-5.png' },
    { id: 6, name: 'Brand 6', url: '/brands/brand-6.png' },
    { id: 7, name: 'Brand 7', url: '/brands/brand-7.png' },
    { id: 8, name: 'Brand 8', url: '/brands/brand-8.png' },
    { id: 9, name: 'Brand 9', url: '/brands/brand-9.png' },
    { id: 10, name: 'Brand 10', url: '/brands/brand-10.png' },
    { id: 11, name: 'Brand 11', url: '/brands/brand-11.png' },
    { id: 12, name: 'Brand 12', url: '/brands/brand-12.png' },
    { id: 13, name: 'Brand 13', url: '/brands/brand-13.png' },
    { id: 14, name: 'Brand 14', url: '/brands/brand-14.png' },
    { id: 15, name: 'Brand 15', url: '/brands/brand-15.png' },
    { id: 16, name: 'Brand 16', url: '/brands/brand-16.png' },
    { id: 17, name: 'Brand 17', url: '/brands/brand-17.png' },
    { id: 18, name: 'Brand 18', url: '/brands/brand-18.png' },
    { id: 19, name: 'Brand 19', url: '/brands/brand-19.png' },
    { id: 20, name: 'Brand 20', url: '/brands/brand-20.png' },
    { id: 21, name: 'Brand 21', url: '/brands/brand-21.png' },
    { id: 22, name: 'Brand 22', url: '/brands/brand-22.png' },
    { id: 23, name: 'Brand 23', url: '/brands/brand-23.png' },
    { id: 24, name: 'Brand 24', url: '/brands/brand-24.png' },
    { id: 25, name: 'Brand 25', url: '/brands/brand-25.png' },
    { id: 26, name: 'Brand 26', url: '/brands/brand-26.png' },
    { id: 27, name: 'Brand 27', url: '/brands/brand-27.png' },
    { id: 28, name: 'Brand 28', url: '/brands/brand-28.png' },
    { id: 29, name: 'Brand 29', url: '/brands/brand-29.png' },
    { id: 30, name: 'Brand 30', url: '/brands/brand-30.png' },
    { id: 31, name: 'Brand 31', url: '/brands/brand-31.png' },
    { id: 32, name: 'Brand 32', url: '/brands/brand-32.png' },
    { id: 33, name: 'Brand 33', url: '/brands/brand-33.png' },
    { id: 34, name: 'Brand 34', url: '/brands/brand-34.png' },
    { id: 35, name: 'Brand 35', url: '/brands/brand-35.png' },
  ];

  // Repeat logos to fill the scroll
  const repeatedLogos = [...logos, ...logos];

  return (
    <section className="py-20 bg-slate-900 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12">
        <div className="text-center">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            Marcas que estarán presentes
          </h2>
          <p className="text-lg text-slate-400">
            Los principales fabricantes de tecnología y sus referentes, reunidos en un solo lugar
          </p>
        </div>
      </div>

      {/* Infinite scroll container */}
      <div className="relative">
        {/* Gradient overlays */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-slate-900 to-transparent z-10"></div>
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-slate-900 to-transparent z-10"></div>

        {/* Scrolling logos */}
        <div className="flex overflow-hidden">
          <div className="flex animate-scroll-left">
            {repeatedLogos.map((logo, index) => (
              <div
                key={`first-${index}`}
                className="flex-shrink-0 mx-8 flex items-center justify-center"
                style={{ width: '400px', height: '215px' }}
              >
                <img
                  src={logo.url}
                  alt={logo.name}
                  className="max-w-full max-h-full object-contain opacity-70 hover:opacity-100 transition-opacity duration-300"
                />
              </div>
            ))}
            {/* Duplicate for seamless loop */}
            {repeatedLogos.map((logo, index) => (
              <div
                key={`second-${index}`}
                className="flex-shrink-0 mx-8 flex items-center justify-center"
                style={{ width: '400px', height: '215px' }}
              >
                <img
                  src={logo.url}
                  alt={logo.name}
                  className="max-w-full max-h-full object-contain opacity-70 hover:opacity-100 transition-opacity duration-300"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandLogosSection;
